const comments = [
  {
    name: '影迷小陈',
    avatar: 'C',
    color: 'bg-primary-500',
    time: '2小时前',
    content: '7777影院真的太良心了！更新速度超快，画质也清晰。流浪地球3刚上映没多久这里就有高清版了，省了电影票钱，宅家观影体验也完全不输影院！',
    likes: 128,
  },
  {
    name: '追剧达人Lucy',
    avatar: 'L',
    color: 'bg-accent-500',
    time: '5小时前',
    content: '以前到处找资源太累了，自从朋友推荐了7777影院就再也没换过。片库全、更新快、还不缓冲，追韩剧美剧简直不要太爽，强烈推荐给所有追剧党！',
    likes: 96,
  },
  {
    name: '深夜观影人',
    avatar: '深',
    color: 'bg-secondary-500',
    time: '1天前',
    content: '作为一个纪录片爱好者，7777影院的纪录片专区真的让我惊喜。BBC、NHK的经典纪录片全都有，清晰度也很高，每天晚上看一部，知识量蹭蹭往上涨。',
    likes: 73,
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950">
            观众热评
          </h2>
          <p className="mt-3 text-sm text-foreground-500">听听追剧小伙伴们怎么说</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 max-w-5xl mx-auto">
          {comments.map((item) => (
            <div key={item.name} className="bg-background-100 rounded-xl p-5 md:p-6">
              <div className="flex items-center gap-3 mb-3">
                <div className={`w-10 h-10 rounded-full ${item.color} flex items-center justify-center text-background-50 font-bold text-sm shrink-0`}>
                  {item.avatar}
                </div>
                <div>
                  <p className="font-medium text-sm text-foreground-900">{item.name}</p>
                  <p className="text-xs text-foreground-400">{item.time}</p>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">{item.content}</p>
              <div className="mt-3 flex items-center gap-1.5 text-xs text-foreground-400">
                <i className="ri-heart-line w-4 h-4 flex items-center justify-center"></i>
                <span>{item.likes}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}